import { useAppStore } from "@/store/app/slice";
import type { IPermission } from "../../PermissionGuard/constant";
import { RolePermissions } from "../../PermissionGuard/constant";
import { useCallback } from "react";

export const usePermissions = (): {
  hasPermissions: (permissions: IPermission[]) => boolean;
} => {
  const role = useAppStore((s) => s.user?.role);

  const hasPermissions = useCallback(
    (permissions: IPermission[]) => {
      return role
        ? permissions.every((p) => RolePermissions[role].has(p))
        : false;
    },
    [role],
  );

  return { hasPermissions };
};
